import { ViewportScroller } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CarrinhoService } from 'src/app/service/carrinho.service';
import { ContatoService } from 'src/app/service/contato.service';
import { ExibeMenuService } from 'src/app/service/shared/exibe-menu.service';
import { StorageService } from 'src/app/service/shared/storage.service';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import Tools from 'src/app/util/Tools';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public formVoucher!: FormGroup;
  public formEscola!: FormGroup;

  @Input() isGuid: boolean = false;

  ipAddress = '';

  public loading_btn = false;

  public year = new Date().getFullYear();

  showScrollButton = false;

  // Referênciando variavel grecaptcha
  @ViewChild('divRecaptcha')
  divRecaptcha!: ElementRef<HTMLDivElement>;
  // *
  // * Quando adicionamos o script do reCAPTCHA no
  // * index.html, o script cria uma variável de
  // * escopo global chamada "grecaptcha".
  // * Então para pegar sua referência podemos
  // * acessá-la através do "window"
  // *
  get grecaptcha(): any {
    const w = window as any;
    return w['grecaptcha'];
  }

  constructor(
    private ngZone: NgZone,
    private formBuilder: FormBuilder,
    private carrinho: CarrinhoService,
    private contato: ContatoService,
    private router: Router,
    private storage: StorageService,
    private http: HttpClient,
    private dialog: MatDialog,
    private viewportScroller: ViewportScroller,
    private exibeMenuService: ExibeMenuService
  ) { this.renderizarReCaptcha(); }

  ngOnInit(): void {
    this.getIPAddress();
    this.initForm();
  }

  public renderizarReCaptcha() {
    // *
    // * Para evitar que change detection seja disparado
    // * cada vez que o setTimeout for executado,
    // * executamos essa recorrência fora da zona
    // * do Angular, por isso o usamos o runOutsideAngular
    // *
    // * Para saber mais sobre change detection:
    // * https://consolelog.com.br/como-funciona-change-detection-angular/
    // * 
    this.ngZone.runOutsideAngular(() => {
      // *
      // * Se o "grecaptcha" ainda não foi carregado ou
      // * o elemento <div> onde o reCAPTCHA será
      // * renderizado ainda não foi construído,
      // * aguardamos algum tempo e executamos novamente
      // * este método:
      // *
      if (!this.grecaptcha || !this.divRecaptcha) {
        setTimeout(() => {
          this.renderizarReCaptcha();
        }, 500);

        return;
      }

      // * Se chegou aqui é porque o recaptcha já está
      // * carregado. Então solicitamos sua renderização
      // * na tela.
      const idElemento =
        this.divRecaptcha.nativeElement.getAttribute('id');

      this.grecaptcha.render(idElemento, {
        sitekey: '6Lca_nkpAAAAANZCS80-ZF5jL96XAjpwuJ2Tjvi9',
        callback: (response: string) => {
          // * Este método é chamado quando o usuário
          // * resolver o desafio do CAPTCHA
          this.ngZone.run(() => {
            this.formEscola.get('recaptcha')?.setValue(response);
          });
        },
      });
    });
  }

  public enviaFormularioContato() {
    const dados = {
      ...this.formEscola.value,
      whatsapp: Tools.formatarTelefone(this.formEscola.get('whatsapp')?.value)
    }

    if (this.formEscola.valid) {
      this.contato.contatoEscola(dados).subscribe(res => {

        if (res.status) {
          this.dialog.open(DialogComponent, { data: res.mensagem })
          this.formEscola.reset();

          this.formEscola.get('tipo_escola')?.setValue('');
          this.formEscola.get('segmento')?.setValue('');
          this.formEscola.get('cargo_escola')?.setValue('');
          this.formEscola.get('alunos_escola')?.setValue('');
        }
      });
    }
  }

  private initForm() {
    this.formVoucher = this.formBuilder.group({
      voucher: ['', Validators.required]
    })

    this.formEscola = this.formBuilder.group({
      nome: ['', Validators.required],
      email: ['', Validators.required],
      whatsapp: ['', Validators.required],
      cidade: ['', Validators.required],
      nome_escola: ['', Validators.required],
      tipo_escola: ['', Validators.required],
      segmento: ['', Validators.required],
      cargo_escola: ['', Validators.required],
      alunos_escola: ['', Validators.required],
      mensagem: ['', Validators.required],
      recaptcha: ['', Validators.required]
    })
  }

  private getIPAddress() {
    this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  public acessar() {
    const dados = {
      voucher: this.formVoucher.get('voucher')?.value,
      ip: this.ipAddress,
    }

    if (this.formVoucher.valid) {
      this.loading_btn = true;
      this.carrinho.voucher(dados).subscribe({
        next: (res) => {
          if (res != '') {
            if (!!res.guid) {
              this.storage.saveGUIDSession(res.guid, res.escola)
              this.router.navigate(['/dependente']);
              this.loading_btn = false;
              this.exibeMenuService.toggleMenu(false); 
            } else {
              this.dialog.open(DialogComponent, { data: res.mensagem })
              this.loading_btn = false;
            }
          } else {
            this.dialog.open(DialogComponent, { data: 'O voucher que você digitou é inválido ou a escola está inativa para compra.' })
            this.loading_btn = false;
          }
        },
        error: (res) => {
          this.dialog.open(DialogComponent, { data: res.message })
          this.loading_btn = false;
        }
      })
    }
  }

  @HostListener('window:scroll', [])

  onWindowScroll() {
    const sectionToReach = document.getElementById('banner');
    if (!sectionToReach) {
      return;
    }

    const scrollPosition = this.viewportScroller.getScrollPosition()[1];
    const sectionPosition = sectionToReach.offsetTop;

    this.showScrollButton = scrollPosition > sectionPosition;
  }

  scrollToTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
